				import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TrackerDocService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('TrackerDoc');
	}
	
	loadAll() : Observable<ePM.Logic.TrackerDoc[]> {
		return this.myBaseService.loadAll(this.url);
	}
	getHistory(id: System.Guid): Observable<ePM.Logic.TrackerDoc[]> {
		return this.myBaseService.loadAll(this.url + '/History/' + id);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}
				